import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';

const rowsToHide = ['IsDeleted', 'DatasetId'];

interface StudyMember {
    Name: string;
}

const SmReviews = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              ...removePropertiesFromObject(oldRecord, rowsToHide),
          }
        : oldRecord;

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              ...removePropertiesFromObject(newRecord, rowsToHide),
          }
        : newRecord;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord,
            newRecord,
            oldItem,
            newItem,
            field,
            arrayOfObjectsV2: {
                Reviewers: {
                    valueResolver: (item: unknown, index) => {
                        if (!item) {
                            return null;
                        }
                        const studyMember = item as StudyMember;
                        return `${index + 1}: ${studyMember.Name}`;
                    },
                    compareField: '_id',
                },
            },
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export default SmReviews;
